import { Link } from 'react-router-dom';
import { UserList } from '../features/users/UserList';

export function UserListPage(): JSX.Element {
  return (
    <section>
      <header className="mb-4 flex items-center justify-between">
        <h1 className="text-2xl font-semibold">使用者管理</h1>
        <Link
          to="/settings/users/new"
          className="bg-blue-600 text-white px-3 py-1.5 rounded hover:bg-blue-700 text-sm"
        >
          新增使用者
        </Link>
      </header>
      <UserList />
    </section>
  );
}
